module.exports = __webpack_public_path__ + "static/media/auth-check-user.4629bdd240c3d17a89754c7052fd6b4c.svg";